import { render, staticRenderFns } from "./CreateTexture.vue?vue&type=template&id=a1ae4dea&"
import script from "./CreateTexture.vue?vue&type=script&lang=js&"
export * from "./CreateTexture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports